'use client';

import { ProgressButton } from './ProgressButton';
import { useFlowProgressButtonState } from './useFlowProgressButtonState';
import { useNavigation } from '../../hooks/useNavigation';

export const NextButton = ({ children }: { children: React.ReactNode }) => {
  const { onNext } = useNavigation();

  const buttonProps = useFlowProgressButtonState(onNext);

  return (
    <ProgressButton buttonType="primary" {...buttonProps}>
      {children}
    </ProgressButton>
  );
};
